var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/themes/base/index.ts
var base_exports = {};
__export(base_exports, {
  breakpoints: () => breakpoints,
  colors: () => colors,
  containers: () => containers,
  fontFamily: () => fontFamily,
  fontSizes: () => fontSizes,
  fontWeights: () => fontWeights,
  iconSizes: () => iconSizes,
  lineHeights: () => lineHeights,
  minHeight: () => minHeight,
  outline: () => outline,
  radii: () => radii,
  shadows: () => shadows,
  sizes: () => sizes,
  spacings: () => spacings,
  zIndices: () => zIndices
});
var radii = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#4A4A4A",
  colorHighlightLight: "#F7F7F7",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#CCCCCC",
  colorAccentB2BLight: "#ffffff",
  colorAccentB2BHover: "#A6A6A6",
  colorAccentB2BActive: "#616161",
  colorAccentB2CDefault: "#CCCCCC",
  colorAccentB2CLight: "#ffffff",
  colorAccentB2CHover: "#A6A6A6",
  colorAccentB2CActive: "#616161",
  colorActionableDefault: "#CCCCCC",
  colorActionableLightDefault: "#ffffff",
  colorActionableLightHover: "#F7F7F7",
  colorActionableLightActive: "#EBEBEB",
  colorActionableHover: "#A6A6A6",
  colorActionableActive: "#616161",
  colorActionableB2CDefault: "#CCCCCC",
  colorActionableB2CHover: "#A6A6A6",
  colorActionableB2CActive: "#616161",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#CCCCCC",
  colorBrandLight: "#ffffff",
  colorBrandHover: "#A6A6A6",
  colorBrandActive: "#616161",
  colorPrimaryDefault: "#CCCCCC",
  colorPrimaryLight: "#ffffff",
  colorPrimaryLightHover: "#F7F7F7",
  colorPrimaryLightActive: "#EBEBEB",
  colorPrimaryHover: "#A6A6A6",
  colorPrimaryActive: "#616161",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#CCCCCC",
  colorStatusInfoLight: "#ffffff",
  colorStatusInfoActive: "#616161",
  colorStatusInfoHover: "#A6A6A6",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#ffffff",
  componentButtonSecondaryBgColorHover: "#F7F7F7",
  componentButtonSecondaryBgColorActive: "#EBEBEB",
  componentButtonSecondaryBorderColorDefault: "#ffffff",
  componentButtonSecondaryBorderColorHover: "#F7F7F7",
  componentButtonSecondaryBorderColorActive: "#EBEBEB",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#ffffff",
  componentButtonTertiaryBgColorActive: "#F7F7F7",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#A6A6A6",
  componentButtonTertiaryBorderColorActive: "#A6A6A6",
  componentButtonTertiaryTextColorDefault: "#A6A6A6",
  componentButtonTertiaryTextColorHover: "#A6A6A6",
  componentButtonTertiaryTextColorActive: "#616161",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#CCCCCC",
  componentButtonLinkTextColorHover: "#A6A6A6",
  componentButtonLinkTextColorActive: "#616161",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#CCCCCC",
  componentButtonInvertedTextColorHover: "#A6A6A6",
  componentButtonInvertedTextColorActive: "#616161",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily = {
  fontFamilyPrimary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilySecondary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyBody: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyHeading: "'Helvetica Neue', Arial, sans-serif"
};
var fontSizes = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/careerstructure/index.ts
var careerstructure_exports = {};
__export(careerstructure_exports, {
  breakpoints: () => breakpoints2,
  colors: () => colors2,
  containers: () => containers2,
  fontFamily: () => fontFamily2,
  fontSizes: () => fontSizes2,
  fontWeights: () => fontWeights2,
  iconSizes: () => iconSizes2,
  lineHeights: () => lineHeights2,
  minHeight: () => minHeight2,
  outline: () => outline2,
  radii: () => radii2,
  shadows: () => shadows2,
  sizes: () => sizes2,
  spacings: () => spacings2,
  zIndices: () => zIndices2
});
var radii2 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows2 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints2 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors2 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#1A6BA7",
  colorHighlightLight: "#F3F7FB",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#1A6BA7",
  colorAccentB2BLight: "#C6E4F7",
  colorAccentB2BHover: "#124A73",
  colorAccentB2BActive: "#0D3653",
  colorAccentB2CDefault: "#1A6BA7",
  colorAccentB2CLight: "#C6E4F7",
  colorAccentB2CHover: "#124A73",
  colorAccentB2CActive: "#0D3653",
  colorActionableDefault: "#1A6BA7",
  colorActionableLightDefault: "#C6E4F7",
  colorActionableLightHover: "#AED7F2",
  colorActionableLightActive: "#8DC5EB",
  colorActionableHover: "#124A73",
  colorActionableActive: "#0D3653",
  colorActionableB2CDefault: "#1A6BA7",
  colorActionableB2CHover: "#124A73",
  colorActionableB2CActive: "#0D3653",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#0D3653",
  colorBrandLight: "#C6E4F7",
  colorBrandHover: "#124A73",
  colorBrandActive: "#1A6BA7",
  colorPrimaryDefault: "#1A6BA7",
  colorPrimaryLight: "#C6E4F7",
  colorPrimaryLightHover: "#AED7F2",
  colorPrimaryLightActive: "#8DC5EB",
  colorPrimaryHover: "#124A73",
  colorPrimaryActive: "#0D3653",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F7F7F7",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#F1FEEC",
  colorStatusPositiveFg: "#007630",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#A37B00",
  colorStatusInfoDefault: "#1A6BA7",
  colorStatusInfoLight: "#C6E4F7",
  colorStatusInfoActive: "#0D3653",
  colorStatusInfoHover: "#124A73",
  colorStatusInfoBg: "#C6E4F7",
  colorStatusInfoFg: "#0D3653",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#C6E4F7",
  componentButtonSecondaryBgColorHover: "#AED7F2",
  componentButtonSecondaryBgColorActive: "#8DC5EB",
  componentButtonSecondaryBorderColorDefault: "#C6E4F7",
  componentButtonSecondaryBorderColorHover: "#AED7F2",
  componentButtonSecondaryBorderColorActive: "#8DC5EB",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#C6E4F7",
  componentButtonTertiaryBgColorActive: "#AED7F2",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#124A73",
  componentButtonTertiaryBorderColorActive: "#124A73",
  componentButtonTertiaryTextColorDefault: "#124A73",
  componentButtonTertiaryTextColorHover: "#124A73",
  componentButtonTertiaryTextColorActive: "#0D3653",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#1A6BA7",
  componentButtonLinkTextColorHover: "#124A73",
  componentButtonLinkTextColorActive: "#0D3653",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#1A6BA7",
  componentButtonInvertedTextColorHover: "#124A73",
  componentButtonInvertedTextColorActive: "#0D3653",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline2 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes2 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings2 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily2 = {
  fontFamilyPrimary: "Arial, Sans-serif",
  fontFamilySecondary: "'Nunito Sans', Arial, sans-serif",
  fontFamilyBody: "Arial, Sans-serif",
  fontFamilyHeading: "'Nunito Sans', Arial, sans-serif"
};
var fontSizes2 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights2 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights2 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices2 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight2 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers2 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes2 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/caterer/index.ts
var caterer_exports = {};
__export(caterer_exports, {
  breakpoints: () => breakpoints3,
  colors: () => colors3,
  containers: () => containers3,
  fontFamily: () => fontFamily3,
  fontSizes: () => fontSizes3,
  fontWeights: () => fontWeights3,
  iconSizes: () => iconSizes3,
  lineHeights: () => lineHeights3,
  minHeight: () => minHeight3,
  outline: () => outline3,
  radii: () => radii3,
  shadows: () => shadows3,
  sizes: () => sizes3,
  spacings: () => spacings3,
  zIndices: () => zIndices3
});
var radii3 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows3 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #C88FCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints3 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors3 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#924199",
  colorHighlightLight: "#F9F5FA",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#924199",
  colorAccentB2BLight: "#F0CEF2",
  colorAccentB2BHover: "#792D80",
  colorAccentB2BActive: "#601F66",
  colorAccentB2CDefault: "#924199",
  colorAccentB2CLight: "#F0CEF2",
  colorAccentB2CHover: "#792D80",
  colorAccentB2CActive: "#601F66",
  colorActionableDefault: "#924199",
  colorActionableLightDefault: "#F0CEF2",
  colorActionableLightHover: "#B982BD",
  colorActionableLightActive: "#C88FCC",
  colorActionableHover: "#792D80",
  colorActionableActive: "#601F66",
  colorActionableB2CDefault: "#924199",
  colorActionableB2CHover: "#792D80",
  colorActionableB2CActive: "#601F66",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#C88FCC",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#C88FCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#555555",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#333333",
  colorBrandActive: "#000000",
  colorPrimaryDefault: "#924199",
  colorPrimaryLight: "#F0CEF2",
  colorPrimaryLightHover: "#B982BD",
  colorPrimaryLightActive: "#C88FCC",
  colorPrimaryHover: "#792D80",
  colorPrimaryActive: "#601F66",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#924199",
  colorStatusInfoLight: "#F0CEF2",
  colorStatusInfoActive: "#616161",
  colorStatusInfoHover: "#A6A6A6",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#F0CEF2",
  componentButtonSecondaryBgColorHover: "#B982BD",
  componentButtonSecondaryBgColorActive: "#C88FCC",
  componentButtonSecondaryBorderColorDefault: "#F0CEF2",
  componentButtonSecondaryBorderColorHover: "#B982BD",
  componentButtonSecondaryBorderColorActive: "#C88FCC",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#F0CEF2",
  componentButtonTertiaryBgColorActive: "#B982BD",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#792D80",
  componentButtonTertiaryBorderColorActive: "#792D80",
  componentButtonTertiaryTextColorDefault: "#792D80",
  componentButtonTertiaryTextColorHover: "#792D80",
  componentButtonTertiaryTextColorActive: "#601F66",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#924199",
  componentButtonLinkTextColorHover: "#792D80",
  componentButtonLinkTextColorActive: "#601F66",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#924199",
  componentButtonInvertedTextColorHover: "#792D80",
  componentButtonInvertedTextColorActive: "#601F66",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline3 = {
  outlineDefault: "2px solid #C88FCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #C88FCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes3 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings3 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily3 = {
  fontFamilyPrimary: "Arial, Sans-serif",
  fontFamilySecondary: "'Nunito Sans', Arial, sans-serif",
  fontFamilyBody: "Arial, Sans-serif",
  fontFamilyHeading: "'Nunito Sans', Arial, sans-serif"
};
var fontSizes3 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights3 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights3 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices3 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight3 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers3 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes3 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/catererglobal/index.ts
var catererglobal_exports = {};
__export(catererglobal_exports, {
  breakpoints: () => breakpoints4,
  colors: () => colors4,
  containers: () => containers4,
  fontFamily: () => fontFamily4,
  fontSizes: () => fontSizes4,
  fontWeights: () => fontWeights4,
  iconSizes: () => iconSizes4,
  lineHeights: () => lineHeights4,
  minHeight: () => minHeight4,
  outline: () => outline4,
  radii: () => radii4,
  shadows: () => shadows4,
  sizes: () => sizes4,
  spacings: () => spacings4,
  zIndices: () => zIndices4
});
var radii4 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows4 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #BD82D9",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints4 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors4 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#8E4FAC",
  colorHighlightLight: "#F9F6FB",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#8E4FAC",
  colorAccentB2BLight: "#E8C8FA",
  colorAccentB2BHover: "#713F89",
  colorAccentB2BActive: "#622E75",
  colorAccentB2CDefault: "#8E4FAC",
  colorAccentB2CLight: "#E8C8FA",
  colorAccentB2CHover: "#713F89",
  colorAccentB2CActive: "#622E75",
  colorActionableDefault: "#8E4FAC",
  colorActionableLightDefault: "#E8C8FA",
  colorActionableLightHover: "#D8A8F0",
  colorActionableLightActive: "#BD82D9",
  colorActionableHover: "#713F89",
  colorActionableActive: "#622E75",
  colorActionableB2CDefault: "#8E4FAC",
  colorActionableB2CHover: "#713F89",
  colorActionableB2CActive: "#622E75",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#BD82D9",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#BD82D9",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#333333",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#4A4A4A",
  colorBrandActive: "#616161",
  colorPrimaryDefault: "#8E4FAC",
  colorPrimaryLight: "#E8C8FA",
  colorPrimaryLightHover: "#D8A8F0",
  colorPrimaryLightActive: "#BD82D9",
  colorPrimaryHover: "#713F89",
  colorPrimaryActive: "#622E75",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#8E4FAC",
  colorStatusInfoLight: "#E8C8FA",
  colorStatusInfoActive: "#616161",
  colorStatusInfoHover: "#A6A6A6",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#E8C8FA",
  componentButtonSecondaryBgColorHover: "#D8A8F0",
  componentButtonSecondaryBgColorActive: "#BD82D9",
  componentButtonSecondaryBorderColorDefault: "#E8C8FA",
  componentButtonSecondaryBorderColorHover: "#D8A8F0",
  componentButtonSecondaryBorderColorActive: "#BD82D9",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#E8C8FA",
  componentButtonTertiaryBgColorActive: "#D8A8F0",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#713F89",
  componentButtonTertiaryBorderColorActive: "#713F89",
  componentButtonTertiaryTextColorDefault: "#713F89",
  componentButtonTertiaryTextColorHover: "#713F89",
  componentButtonTertiaryTextColorActive: "#622E75",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#8E4FAC",
  componentButtonLinkTextColorHover: "#713F89",
  componentButtonLinkTextColorActive: "#622E75",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#8E4FAC",
  componentButtonInvertedTextColorHover: "#713F89",
  componentButtonInvertedTextColorActive: "#622E75",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline4 = {
  outlineDefault: "2px solid #BD82D9",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #BD82D9",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes4 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings4 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily4 = {
  fontFamilyPrimary: "'Open Sans', Arial, sans-serif",
  fontFamilySecondary: "Quicksand, 'Open Sans', Arial, sans-serif",
  fontFamilyBody: "'Open Sans', Arial, sans-serif",
  fontFamilyHeading: "Quicksand, 'Open Sans', Arial, sans-serif"
};
var fontSizes4 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights4 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights4 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices4 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight4 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers4 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes4 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/cityjobs/index.ts
var cityjobs_exports = {};
__export(cityjobs_exports, {
  breakpoints: () => breakpoints5,
  colors: () => colors5,
  containers: () => containers5,
  fontFamily: () => fontFamily5,
  fontSizes: () => fontSizes5,
  fontWeights: () => fontWeights5,
  iconSizes: () => iconSizes5,
  lineHeights: () => lineHeights5,
  minHeight: () => minHeight5,
  outline: () => outline5,
  radii: () => radii5,
  shadows: () => shadows5,
  sizes: () => sizes5,
  spacings: () => spacings5,
  zIndices: () => zIndices5
});
var radii5 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows5 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #F2856D",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints5 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors5 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#e64926",
  colorHighlightLight: "#fef6f4",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#e64926",
  colorAccentB2BLight: "#FFD7CC",
  colorAccentB2BHover: "#CF3E1E",
  colorAccentB2BActive: "#C13010",
  colorAccentB2CDefault: "#e64926",
  colorAccentB2CLight: "#FFD7CC",
  colorAccentB2CHover: "#CF3E1E",
  colorAccentB2CActive: "#C13010",
  colorActionableDefault: "#e64926",
  colorActionableLightDefault: "#FFD7CC",
  colorActionableLightHover: "#F7A694",
  colorActionableLightActive: "#F2856D",
  colorActionableHover: "#CF3E1E",
  colorActionableActive: "#C13010",
  colorActionableB2CDefault: "#e64926",
  colorActionableB2CHover: "#CF3E1E",
  colorActionableB2CActive: "#C13010",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#F2856D",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#F2856D",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#000000",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#333333",
  colorBrandActive: "#4A4A4A",
  colorPrimaryDefault: "#e64926",
  colorPrimaryLight: "#FFD7CC",
  colorPrimaryLightHover: "#F7A694",
  colorPrimaryLightActive: "#F2856D",
  colorPrimaryHover: "#CF3E1E",
  colorPrimaryActive: "#C13010",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#e64926",
  colorStatusInfoLight: "#FFD7CC",
  colorStatusInfoActive: "#616161",
  colorStatusInfoHover: "#A6A6A6",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#FFD7CC",
  componentButtonSecondaryBgColorHover: "#F7A694",
  componentButtonSecondaryBgColorActive: "#F2856D",
  componentButtonSecondaryBorderColorDefault: "#FFD7CC",
  componentButtonSecondaryBorderColorHover: "#F7A694",
  componentButtonSecondaryBorderColorActive: "#F2856D",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#FFD7CC",
  componentButtonTertiaryBgColorActive: "#F7A694",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#CF3E1E",
  componentButtonTertiaryBorderColorActive: "#CF3E1E",
  componentButtonTertiaryTextColorDefault: "#CF3E1E",
  componentButtonTertiaryTextColorHover: "#CF3E1E",
  componentButtonTertiaryTextColorActive: "#C13010",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#e64926",
  componentButtonLinkTextColorHover: "#CF3E1E",
  componentButtonLinkTextColorActive: "#C13010",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#e64926",
  componentButtonInvertedTextColorHover: "#CF3E1E",
  componentButtonInvertedTextColorActive: "#C13010",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline5 = {
  outlineDefault: "2px solid #F2856D",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #F2856D",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes5 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings5 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily5 = {
  fontFamilyPrimary: "'Open Sans', Arial, sans-serif",
  fontFamilySecondary: "Oswald, 'Open Sans', Arial, sans-serif",
  fontFamilyBody: "'Open Sans', Arial, sans-serif",
  fontFamilyHeading: "Oswald, 'Open Sans', Arial, sans-serif"
};
var fontSizes5 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights5 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights5 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices5 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight5 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers5 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes5 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/core/index.ts
var core_exports = {};
__export(core_exports, {
  breakpoints: () => breakpoints6,
  colors: () => colors6,
  containers: () => containers6,
  fontFamily: () => fontFamily6,
  fontSizes: () => fontSizes6,
  fontWeights: () => fontWeights6,
  iconSizes: () => iconSizes6,
  lineHeights: () => lineHeights6,
  minHeight: () => minHeight6,
  outline: () => outline6,
  radii: () => radii6,
  shadows: () => shadows6,
  sizes: () => sizes6,
  spacings: () => spacings6,
  zIndices: () => zIndices6
});
var radii6 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "16px",
  componentAutocompleteInputBorderRadius: "999px",
  componentAutocompleteInputBorderBottomRadius: "999px",
  componentAutocompleteInputBorderTopRadius: "999px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "16px",
  componentAutocompletePopoverBorderBottomRadius: "16px",
  componentAutocompletePopoverBorderTopRadius: "16px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "999px",
  componentButtonMediumRadius: "999px",
  componentButtonLargeRadius: "999px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "8px",
  componentCompanyLogoSmallInnerRadius: "6px",
  componentCompanyLogoMediumRadius: "8px",
  componentCompanyLogoMediumInnerRadius: "6px",
  componentCompanyLogoLargeRadius: "8px",
  componentCompanyLogoLargeInnerRadius: "6px",
  componentCompanyLogoXlRadius: "16px",
  componentCompanyLogoXlInnerRadius: "15px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "16px",
  componentTokenRadius: "999px"
};
var shadows6 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #0C2577",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "none",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #CFD6E7, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #CFD6E7, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints6 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors6 = {
  colorPureBlack: "#000000",
  colorBlack: "#0C2577",
  colorGreyDarker: "#25418D",
  colorGreyDark: "#455EA1",
  colorGrey: "#7285B7",
  colorGreyLight: "#A7B3D3",
  colorGreyLighter: "#CFD6E7",
  colorOffWhite: "#F4F4ED",
  colorWhite: "#ffffff",
  colorHighlight: "#F56363",
  colorHighlightLight: "#F2FAFB",
  colorRating: "#FAC731",
  colorAccentB2BDefault: "#008194",
  colorAccentB2BLight: "#E1F6F7",
  colorAccentB2BHover: "#005F75",
  colorAccentB2BActive: "#003954",
  colorAccentB2CDefault: "#008194",
  colorAccentB2CLight: "#E1F6F7",
  colorAccentB2CHover: "#005F75",
  colorAccentB2CActive: "#003954",
  colorActionableDefault: "#008194",
  colorActionableLightDefault: "#E1F6F7",
  colorActionableLightHover: "#C3ECEF",
  colorActionableLightActive: "#87DAE0",
  colorActionableHover: "#005F75",
  colorActionableActive: "#003954",
  colorActionableB2CDefault: "#008194",
  colorActionableB2CHover: "#005F75",
  colorActionableB2CActive: "#003954",
  colorBorderDefault: "#CFD6E7",
  colorBorderFocus: "#87DAE0",
  colorBorderSubdued: "#E8ECF3",
  colorFocusDefault: "#0C2577",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#E8ECF3",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#0C2577",
  colorBrandLight: "#DBE2F6",
  colorBrandHover: "#001A61",
  colorBrandActive: "#001345",
  colorPrimaryDefault: "#008194",
  colorPrimaryLight: "#E1F6F7",
  colorPrimaryLightHover: "#C3ECEF",
  colorPrimaryLightActive: "#87DAE0",
  colorPrimaryHover: "#005F75",
  colorPrimaryActive: "#003954",
  colorStatusDefault: "#0C2577",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#25418D",
  colorStatusDefaultLight: "#E8ECF3",
  colorStatusPositiveDefault: "#007630",
  colorStatusPositiveLight: "#CCFFE0",
  colorStatusPositiveActive: "#007630",
  colorStatusPositiveHover: "#00923B",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#007630",
  colorStatusWarningDefault: "#C09000",
  colorStatusWarningLight: "#FFF5D9",
  colorStatusWarningActive: "#C09000",
  colorStatusWarningHover: "#DDA600",
  colorStatusWarningBg: "#FFF5D9",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#003954",
  colorStatusInfoLight: "#E1F6F7",
  colorStatusInfoActive: "#002638",
  colorStatusInfoHover: "#003954",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#B20018",
  colorStatusNegativeLightHover: "#FA9EAA",
  colorStatusNegativeLightActive: "#ED5A6D",
  colorStatusNegativeLight: "#FFD9DE",
  colorStatusNegativeActive: "#7B0011",
  colorStatusNegativeHover: "#900013",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#7B0011",
  colorTextPrimaryDefault: "#0C2577",
  colorTextSecondaryDefault: "#455EA1",
  colorTextTertiaryDefault: "#7285B7",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#A7B3D3",
  componentAccordionPrimaryBgColor: "#F4F4ED",
  componentAlertDefaultBorderColor: "#0C2577",
  componentAlertPositiveBorderColor: "#007630",
  componentAlertWarningBorderColor: "#C09000",
  componentAlertNegativeBorderColor: "#B20018",
  componentAlertInfoBorderColor: "#003954",
  componentAutocompleteInputContainerBorderColor: "#CFD6E7",
  componentButtonSecondaryBgColorDefault: "#E1F6F7",
  componentButtonSecondaryBgColorHover: "#C3ECEF",
  componentButtonSecondaryBgColorActive: "#87DAE0",
  componentButtonSecondaryBorderColorDefault: "#E1F6F7",
  componentButtonSecondaryBorderColorHover: "#C3ECEF",
  componentButtonSecondaryBorderColorActive: "#87DAE0",
  componentButtonSecondaryTextColorDefault: "#0C2577",
  componentButtonSecondaryTextColorHover: "#0C2577",
  componentButtonSecondaryTextColorActive: "#0C2577",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#E1F6F7",
  componentButtonTertiaryBgColorActive: "#C3ECEF",
  componentButtonTertiaryBorderColorDefault: "#A7B3D3",
  componentButtonTertiaryBorderColorHover: "#005F75",
  componentButtonTertiaryBorderColorActive: "#005F75",
  componentButtonTertiaryTextColorDefault: "#005F75",
  componentButtonTertiaryTextColorHover: "#005F75",
  componentButtonTertiaryTextColorActive: "#003954",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#008194",
  componentButtonLinkTextColorHover: "#005F75",
  componentButtonLinkTextColorActive: "#003954",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#008194",
  componentButtonInvertedTextColorHover: "#005F75",
  componentButtonInvertedTextColorActive: "#003954",
  componentButtonInvertedDisabledBgColor: "#CFD6E7",
  componentButtonInvertedDisabledTextColor: "#A7B3D3",
  componentInputActiveBorderColor: "#A7B3D3",
  componentInputFocusBorderColor: "#A7B3D3"
};
var outline6 = {
  outlineDefault: "2px solid #0C2577",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #0C2577",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes6 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "48px",
  componentDialogSize: "48px"
};
var spacings6 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "16px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily6 = {
  fontFamilyPrimary: "Relative Pro, Arial, sans-serif",
  fontFamilySecondary: "Relative Pro, Arial, sans-serif",
  fontFamilyBody: "Relative Pro, Arial, sans-serif",
  fontFamilyHeading: "Relative Pro, Arial, sans-serif"
};
var fontSizes6 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights6 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 350,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights6 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices6 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight6 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers6 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes6 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/coretwentyfive/index.ts
var coretwentyfive_exports = {};
__export(coretwentyfive_exports, {
  breakpoints: () => breakpoints7,
  colors: () => colors7,
  containers: () => containers7,
  fontFamily: () => fontFamily7,
  fontSizes: () => fontSizes7,
  fontWeights: () => fontWeights7,
  iconSizes: () => iconSizes7,
  lineHeights: () => lineHeights7,
  minHeight: () => minHeight7,
  outline: () => outline7,
  radii: () => radii7,
  shadows: () => shadows7,
  sizes: () => sizes7,
  spacings: () => spacings7,
  zIndices: () => zIndices7
});
var radii7 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "12px",
  componentAutocompleteInputBorderRadius: "12px",
  componentAutocompleteInputBorderBottomRadius: "12px 12px 0px 0px",
  componentAutocompleteInputBorderTopRadius: "0px 0px 12px 12px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompleteInputGroupLastChildRadius: "0px",
  componentAutocompletePopoverBorderRadius: "12px",
  componentAutocompletePopoverBorderBottomRadius: "0px 0px 12px 12px",
  componentAutocompletePopoverBorderTopRadius: "12px 12px 0px 0px",
  componentAvatarXxsRadius: "4px",
  componentAvatarXsRadius: "4px",
  componentAvatarSmallRadius: "8px",
  componentAvatarMediumRadius: "12px",
  componentAvatarLargeRadius: "16px",
  componentAvatarXlRadius: "16px",
  componentButtonSmallRadius: "8px",
  componentButtonMediumRadius: "10px",
  componentButtonLargeRadius: "12px",
  componentCompanyLogoInnerRadius: "6px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "8px",
  componentCompanyLogoSmallInnerRadius: "4px",
  componentCompanyLogoMediumRadius: "8px",
  componentCompanyLogoMediumInnerRadius: "6px",
  componentCompanyLogoLargeRadius: "8px",
  componentCompanyLogoLargeInnerRadius: "6px",
  componentCompanyLogoXlRadius: "16px",
  componentCompanyLogoXlInnerRadius: "10px",
  componentDrawerRadius: "8px",
  componentMenuRadius: "12px",
  componentTokenRadius: "8px"
};
var shadows7 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #69E0E9",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "0 2px 16px rgba(0, 0, 0, 0.08)",
  componentAlertDisplayBefore: "none",
  componentAutocompleteInputGroupLastChildBoxShadow: "none",
  componentAutocompletePopoverBoxShadowBottom: "inset 0 1px 0 0 #CFD6E7, 0 2px 0 0 #69E0E9, -2px 0 0 0 #69E0E9, 2px 0 0 0 #69E0E9, 0 2px 16px rgba(0, 0, 0, 0.08)",
  componentAutocompletePopoverBoxShadowTop: "0 -2px 0 0 #69E0E9, -2px 0 0 0 #69E0E9, 2px 0 0 0 #69E0E9, inset 0 -1px 0 0 #CFD6E7, 0 -2px 16px rgba(0, 0, 0, 0.08)",
  componentButtonPrimaryBoxShadow: "0 2px 16px rgba(0, 0, 0, 0.08)",
  componentButtonSecondaryBoxShadow: "inset 0 0 0 1px, 0 2px 16px rgba(0, 0, 0, 0.08)",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints7 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors7 = {
  colorPureBlack: "#000000",
  colorBlack: "#0C2577",
  colorGreyDarker: "#25418D",
  colorGreyDark: "#474780",
  colorGrey: "#6D749C",
  colorGreyLight: "#A7B3D3",
  colorGreyLighter: "#CFD6E7",
  colorOffWhite: "#F4F4ED",
  colorWhite: "#ffffff",
  colorHighlight: "#F56363",
  colorHighlightLight: "#F6FDFE",
  colorRating: "#FAC731",
  colorAccentB2BDefault: "#008194",
  colorAccentB2BLight: "#E1F6F7",
  colorAccentB2BHover: "#005F75",
  colorAccentB2BActive: "#003954",
  colorAccentB2CDefault: "#008194",
  colorAccentB2CLight: "#E1F6F7",
  colorAccentB2CHover: "#005F75",
  colorAccentB2CActive: "#003954",
  colorActionableDefault: "#008194",
  colorActionableLightDefault: "#EAFBFC",
  colorActionableLightHover: "#D4F6F9",
  colorActionableLightActive: "#BFF2F5",
  colorActionableHover: "#005F75",
  colorActionableActive: "#003954",
  colorActionableB2CDefault: "#008194",
  colorActionableB2CHover: "#005F75",
  colorActionableB2CActive: "#003954",
  colorBorderDefault: "#CFD6E7",
  colorBorderFocus: "#87DAE0",
  colorBorderSubdued: "#E8ECF3",
  colorFocusDefault: "#69E0E9",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#D4F6F9",
  colorBackgroundPrimaryLight: "#EAFBFC",
  colorBackgroundPrimaryLighter: "#F6FDFE",
  colorBackgroundPrimaryDark: "#BFF2F5",
  colorBackgroundSecondaryDefault: "#F4F4ED",
  colorBackgroundSecondaryLight: "#FBFBF8",
  colorBackgroundSecondaryDark: "#E8ECF3",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#0C2577",
  colorBrandLight: "#DBE2F6",
  colorBrandHover: "#001A61",
  colorBrandActive: "#001345",
  colorPrimaryDefault: "#008194",
  colorPrimaryLight: "#E1F6F7",
  colorPrimaryLightHover: "#C3ECEF",
  colorPrimaryLightActive: "#87DAE0",
  colorPrimaryHover: "#005F75",
  colorPrimaryActive: "#003954",
  colorStatusDefault: "#0C2577",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#25418D",
  colorStatusDefaultLight: "#E8ECF3",
  colorStatusPositiveDefault: "#007630",
  colorStatusPositiveLight: "#CCFFE0",
  colorStatusPositiveActive: "#007630",
  colorStatusPositiveHover: "#00923B",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#007630",
  colorStatusWarningDefault: "#C09000",
  colorStatusWarningLight: "#FFF5D9",
  colorStatusWarningActive: "#C09000",
  colorStatusWarningHover: "#DDA600",
  colorStatusWarningBg: "#FFF5D9",
  colorStatusWarningFg: "#C09000",
  colorStatusInfoDefault: "#003954",
  colorStatusInfoLight: "#E1F6F7",
  colorStatusInfoActive: "#002638",
  colorStatusInfoHover: "#003954",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#B20018",
  colorStatusNegativeLightHover: "#FA9EAA",
  colorStatusNegativeLightActive: "#ED5A6D",
  colorStatusNegativeLight: "#FFD9DE",
  colorStatusNegativeActive: "#7B0011",
  colorStatusNegativeHover: "#900013",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#7B0011",
  colorTextPrimaryDefault: "#0A1E5F",
  colorTextSecondaryDefault: "#474780",
  colorTextTertiaryDefault: "#6D749C",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#A7B3D3",
  componentAccordionPrimaryBgColor: "#F8F8FB",
  componentAlertDefaultBorderColor: "#0C2577",
  componentAlertPositiveBorderColor: "#007630",
  componentAlertWarningBorderColor: "#C09000",
  componentAlertNegativeBorderColor: "#B20018",
  componentAlertInfoBorderColor: "#003954",
  componentAutocompleteInputContainerBorderColor: "transparent",
  componentButtonSecondaryBgColorDefault: "#ffffff",
  componentButtonSecondaryBgColorHover: "#ffffff",
  componentButtonSecondaryBgColorActive: "#ffffff",
  componentButtonSecondaryBorderColorDefault: "#A7B3D3",
  componentButtonSecondaryBorderColorHover: "#005F75",
  componentButtonSecondaryBorderColorActive: "#003954",
  componentButtonSecondaryTextColorDefault: "#005F75",
  componentButtonSecondaryTextColorHover: "#005F75",
  componentButtonSecondaryTextColorActive: "#003954",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#EAFBFC",
  componentButtonTertiaryBgColorActive: "#D4F6F9",
  componentButtonTertiaryBorderColorDefault: "#A7B3D3",
  componentButtonTertiaryBorderColorHover: "#005F75",
  componentButtonTertiaryBorderColorActive: "#005F75",
  componentButtonTertiaryTextColorDefault: "#005F75",
  componentButtonTertiaryTextColorHover: "#005F75",
  componentButtonTertiaryTextColorActive: "#003954",
  componentButtonLinkTextDecoration: "none",
  componentButtonLinkTextColorDefault: "#474780",
  componentButtonLinkTextColorHover: "#0A1E5F",
  componentButtonLinkTextColorActive: "#0A1E5F",
  componentButtonInvertedBgColorDefault: "transparent",
  componentButtonInvertedBgColorHover: "transparent",
  componentButtonInvertedBgColorActive: "transparent",
  componentButtonInvertedBorderColorDefault: "transparent",
  componentButtonInvertedBorderColorHover: "transparent",
  componentButtonInvertedBorderColorActive: "transparent",
  componentButtonInvertedTextColorDefault: "#ffffff",
  componentButtonInvertedTextColorHover: "#F2F3F6",
  componentButtonInvertedTextColorActive: "#ffffff",
  componentButtonInvertedDisabledBgColor: "transparent",
  componentButtonInvertedDisabledTextColor: "#A7B3D3",
  componentInputActiveBorderColor: "transparent",
  componentInputFocusBorderColor: "transparent"
};
var outline7 = {
  outlineDefault: "2px solid #69E0E9",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "0px solid transparent",
  componentAutocompleteInputGroupOutline: "2px solid #69E0E9"
};
var sizes7 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "48px",
  componentDialogSize: "52px"
};
var spacings7 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "1px 0 0 0",
  componentAutocompletePopoverOffset: "0px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "2px",
  componentCompanyLogoSmallPadding: "4px",
  componentCompanyLogoMediumPadding: "6px",
  componentCompanyLogoLargePadding: "8px",
  componentCompanyLogoXlPadding: "10px",
  componentInputFocusOutlineOffset: "0px",
  componentMenuPaddingY: "12px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily7 = {
  fontFamilyPrimary: "Relative Pro, Arial, sans-serif",
  fontFamilySecondary: "Relative Pro, Arial, sans-serif",
  fontFamilyBody: "Relative Pro, Arial, sans-serif",
  fontFamilyHeading: "Relative Pro, Arial, sans-serif"
};
var fontSizes7 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights7 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 350,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 500
};
var lineHeights7 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices7 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight7 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers7 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes7 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/cwjobs/index.ts
var cwjobs_exports = {};
__export(cwjobs_exports, {
  breakpoints: () => breakpoints8,
  colors: () => colors8,
  containers: () => containers8,
  fontFamily: () => fontFamily8,
  fontSizes: () => fontSizes8,
  fontWeights: () => fontWeights8,
  iconSizes: () => iconSizes8,
  lineHeights: () => lineHeights8,
  minHeight: () => minHeight8,
  outline: () => outline8,
  radii: () => radii8,
  shadows: () => shadows8,
  sizes: () => sizes8,
  spacings: () => spacings8,
  zIndices: () => zIndices8
});
var radii8 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows8 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints8 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors8 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#F8981D",
  colorHighlightLight: "#FFFAF3",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#F8981D",
  colorAccentB2BLight: "#FFE9CC",
  colorAccentB2BHover: "#D17119",
  colorAccentB2BActive: "#C36117",
  colorAccentB2CDefault: "#F8981D",
  colorAccentB2CLight: "#FFE9CC",
  colorAccentB2CHover: "#D17119",
  colorAccentB2CActive: "#C36117",
  colorActionableDefault: "#007F99",
  colorActionableLightDefault: "#D9F8FF",
  colorActionableLightHover: "#9DE3F2",
  colorActionableLightActive: "#42BCDF",
  colorActionableHover: "#005768",
  colorActionableActive: "#003E4A",
  colorActionableB2CDefault: "#F8981D",
  colorActionableB2CHover: "#D17119",
  colorActionableB2CActive: "#C36117",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#555555",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#333333",
  colorBrandActive: "#000000",
  colorPrimaryDefault: "#F8981D",
  colorPrimaryLight: "#FFE9CC",
  colorPrimaryLightHover: "#FAD7B6",
  colorPrimaryLightActive: "#FAC696",
  colorPrimaryHover: "#D17119",
  colorPrimaryActive: "#C36117",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#007F99",
  colorStatusInfoLight: "#D9F8FF",
  colorStatusInfoActive: "#003E4A",
  colorStatusInfoHover: "#005768",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#FFE9CC",
  componentButtonSecondaryBgColorHover: "#FAD7B6",
  componentButtonSecondaryBgColorActive: "#FAC696",
  componentButtonSecondaryBorderColorDefault: "#FFE9CC",
  componentButtonSecondaryBorderColorHover: "#FAD7B6",
  componentButtonSecondaryBorderColorActive: "#FAC696",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#D9F8FF",
  componentButtonTertiaryBgColorActive: "#9DE3F2",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#D17119",
  componentButtonTertiaryBorderColorActive: "#D17119",
  componentButtonTertiaryTextColorDefault: "#D17119",
  componentButtonTertiaryTextColorHover: "#D17119",
  componentButtonTertiaryTextColorActive: "#C36117",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#007F99",
  componentButtonLinkTextColorHover: "#005768",
  componentButtonLinkTextColorActive: "#003E4A",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#F8981D",
  componentButtonInvertedTextColorHover: "#D17119",
  componentButtonInvertedTextColorActive: "#C36117",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline8 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes8 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings8 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily8 = {
  fontFamilyPrimary: "Arial, sans-serif",
  fontFamilySecondary: "Montserrat, Arial, sans-serif",
  fontFamilyBody: "Arial, sans-serif",
  fontFamilyHeading: "Montserrat, Arial, sans-serif"
};
var fontSizes8 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights8 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights8 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices8 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight8 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers8 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes8 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/emedcareers/index.ts
var emedcareers_exports = {};
__export(emedcareers_exports, {
  breakpoints: () => breakpoints9,
  colors: () => colors9,
  containers: () => containers9,
  fontFamily: () => fontFamily9,
  fontSizes: () => fontSizes9,
  fontWeights: () => fontWeights9,
  iconSizes: () => iconSizes9,
  lineHeights: () => lineHeights9,
  minHeight: () => minHeight9,
  outline: () => outline9,
  radii: () => radii9,
  shadows: () => shadows9,
  sizes: () => sizes9,
  spacings: () => spacings9,
  zIndices: () => zIndices9
});
var radii9 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows9 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #93D9C9",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints9 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors9 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#31a389",
  colorHighlightLight: "#f4faf9",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#31a389",
  colorAccentB2BLight: "#D4FAF1",
  colorAccentB2BHover: "#257c68",
  colorAccentB2BActive: "#15725C",
  colorAccentB2CDefault: "#31a389",
  colorAccentB2CLight: "#D4FAF1",
  colorAccentB2CHover: "#257c68",
  colorAccentB2CActive: "#15725C",
  colorActionableDefault: "#31a389",
  colorActionableLightDefault: "#D4FAF1",
  colorActionableLightHover: "#BDF2E6",
  colorActionableLightActive: "#93D9C9",
  colorActionableHover: "#257c68",
  colorActionableActive: "#15725C",
  colorActionableB2CDefault: "#31a389",
  colorActionableB2CHover: "#257c68",
  colorActionableB2CActive: "#15725C",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#93D9C9",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#93D9C9",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#000000",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#333333",
  colorBrandActive: "#4A4A4A",
  colorPrimaryDefault: "#31a389",
  colorPrimaryLight: "#D4FAF1",
  colorPrimaryLightHover: "#BDF2E6",
  colorPrimaryLightActive: "#93D9C9",
  colorPrimaryHover: "#257c68",
  colorPrimaryActive: "#15725C",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#31a389",
  colorStatusInfoLight: "#D4FAF1",
  colorStatusInfoActive: "#616161",
  colorStatusInfoHover: "#A6A6A6",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#D4FAF1",
  componentButtonSecondaryBgColorHover: "#BDF2E6",
  componentButtonSecondaryBgColorActive: "#93D9C9",
  componentButtonSecondaryBorderColorDefault: "#D4FAF1",
  componentButtonSecondaryBorderColorHover: "#BDF2E6",
  componentButtonSecondaryBorderColorActive: "#93D9C9",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#D4FAF1",
  componentButtonTertiaryBgColorActive: "#BDF2E6",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#257c68",
  componentButtonTertiaryBorderColorActive: "#257c68",
  componentButtonTertiaryTextColorDefault: "#257c68",
  componentButtonTertiaryTextColorHover: "#257c68",
  componentButtonTertiaryTextColorActive: "#15725C",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#31a389",
  componentButtonLinkTextColorHover: "#257c68",
  componentButtonLinkTextColorActive: "#15725C",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#31a389",
  componentButtonInvertedTextColorHover: "#257c68",
  componentButtonInvertedTextColorActive: "#15725C",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline9 = {
  outlineDefault: "2px solid #93D9C9",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #93D9C9",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes9 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings9 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily9 = {
  fontFamilyPrimary: "'Open Sans', Arial, sans-serif",
  fontFamilySecondary: "Poppins, 'Open Sans', Arial, sans-serif",
  fontFamilyBody: "'Open Sans', Arial, sans-serif",
  fontFamilyHeading: "Poppins, 'Open Sans', Arial, sans-serif"
};
var fontSizes9 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights9 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights9 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices9 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight9 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers9 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes9 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/irishjobs/index.ts
var irishjobs_exports = {};
__export(irishjobs_exports, {
  breakpoints: () => breakpoints10,
  colors: () => colors10,
  containers: () => containers10,
  fontFamily: () => fontFamily10,
  fontSizes: () => fontSizes10,
  fontWeights: () => fontWeights10,
  iconSizes: () => iconSizes10,
  lineHeights: () => lineHeights10,
  minHeight: () => minHeight10,
  outline: () => outline10,
  radii: () => radii10,
  shadows: () => shadows10,
  sizes: () => sizes10,
  spacings: () => spacings10,
  zIndices: () => zIndices10
});
var radii10 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows10 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #73D9F7",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints10 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors10 = {
  colorPureBlack: "#000000",
  colorBlack: "#323232",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#11BFF3",
  colorHighlightLight: "#F3FAFC",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#0A9BC7",
  colorAccentB2BLight: "#DDF6FD",
  colorAccentB2BHover: "#087597",
  colorAccentB2BActive: "#054F66",
  colorAccentB2CDefault: "#0A9BC7",
  colorAccentB2CLight: "#DDF6FD",
  colorAccentB2CHover: "#087597",
  colorAccentB2CActive: "#054F66",
  colorActionableDefault: "#0A9BC7",
  colorActionableLightDefault: "#DDF6FD",
  colorActionableLightHover: "#C5EFFB",
  colorActionableLightActive: "#A3E6FA",
  colorActionableHover: "#087597",
  colorActionableActive: "#054F66",
  colorActionableB2CDefault: "#0A9BC7",
  colorActionableB2CHover: "#087597",
  colorActionableB2CActive: "#054F66",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#73D9F7",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#73D9F7",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#4A4A4A",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#323232",
  colorBrandActive: "#000000",
  colorPrimaryDefault: "#0A9BC7",
  colorPrimaryLight: "#DDF6FD",
  colorPrimaryLightHover: "#C5EFFB",
  colorPrimaryLightActive: "#A3E6FA",
  colorPrimaryHover: "#087597",
  colorPrimaryActive: "#054F66",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#0A9BC7",
  colorStatusInfoLight: "#DDF6FD",
  colorStatusInfoActive: "#087597",
  colorStatusInfoHover: "#0A9BC7",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#E83232",
  colorStatusNegativeLightHover: "#F7BABA",
  colorStatusNegativeLightActive: "#F28C8C",
  colorStatusNegativeLight: "#FCE8E8",
  colorStatusNegativeActive: "#A11212",
  colorStatusNegativeHover: "#CE1717",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#A11212",
  colorTextPrimaryDefault: "#323232",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#DDF6FD",
  componentButtonSecondaryBgColorHover: "#C5EFFB",
  componentButtonSecondaryBgColorActive: "#A3E6FA",
  componentButtonSecondaryBorderColorDefault: "#DDF6FD",
  componentButtonSecondaryBorderColorHover: "#C5EFFB",
  componentButtonSecondaryBorderColorActive: "#A3E6FA",
  componentButtonSecondaryTextColorDefault: "#323232",
  componentButtonSecondaryTextColorHover: "#323232",
  componentButtonSecondaryTextColorActive: "#323232",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#DDF6FD",
  componentButtonTertiaryBgColorActive: "#C5EFFB",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#087597",
  componentButtonTertiaryBorderColorActive: "#087597",
  componentButtonTertiaryTextColorDefault: "#087597",
  componentButtonTertiaryTextColorHover: "#087597",
  componentButtonTertiaryTextColorActive: "#054F66",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#0A9BC7",
  componentButtonLinkTextColorHover: "#087597",
  componentButtonLinkTextColorActive: "#054F66",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#0A9BC7",
  componentButtonInvertedTextColorHover: "#087597",
  componentButtonInvertedTextColorActive: "#054F66",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline10 = {
  outlineDefault: "2px solid #73D9F7",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #73D9F7",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes10 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings10 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily10 = {
  fontFamilyPrimary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilySecondary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyBody: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyHeading: "'Helvetica Neue', Arial, sans-serif"
};
var fontSizes10 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights10 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights10 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices10 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight10 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers10 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes10 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/jobsie/index.ts
var jobsie_exports = {};
__export(jobsie_exports, {
  breakpoints: () => breakpoints11,
  colors: () => colors11,
  containers: () => containers11,
  fontFamily: () => fontFamily11,
  fontSizes: () => fontSizes11,
  fontWeights: () => fontWeights11,
  iconSizes: () => iconSizes11,
  lineHeights: () => lineHeights11,
  minHeight: () => minHeight11,
  outline: () => outline11,
  radii: () => radii11,
  shadows: () => shadows11,
  sizes: () => sizes11,
  spacings: () => spacings11,
  zIndices: () => zIndices11
});
var radii11 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows11 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #04E7E0",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #D2D5E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #D2D5E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints11 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors11 = {
  colorPureBlack: "#001624",
  colorBlack: "#00263D",
  colorGreyDarker: "#383F5B",
  colorGreyDark: "#4D5770",
  colorGrey: "#6E7B9B",
  colorGreyLight: "#959EB6",
  colorGreyLighter: "#D2D5E0",
  colorOffWhite: "#F6F6F9",
  colorWhite: "#ffffff",
  colorHighlight: "#02837F",
  colorHighlightLight: "#F2F9F8",
  colorRating: "#FCDE78",
  colorAccentB2BDefault: "#02837F",
  colorAccentB2BLight: "#DCFFFD",
  colorAccentB2BHover: "#01504E",
  colorAccentB2BActive: "#013C3B",
  colorAccentB2CDefault: "#02837F",
  colorAccentB2CLight: "#DCFFFD",
  colorAccentB2CHover: "#01504E",
  colorAccentB2CActive: "#013C3B",
  colorActionableDefault: "#02837F",
  colorActionableLightDefault: "#DCFFFD",
  colorActionableLightHover: "#9AFEFA",
  colorActionableLightActive: "#04E7E0",
  colorActionableHover: "#01504E",
  colorActionableActive: "#013C3B",
  colorActionableB2CDefault: "#02837F",
  colorActionableB2CHover: "#01504E",
  colorActionableB2CActive: "#013C3B",
  colorBorderDefault: "#D2D5E0",
  colorBorderFocus: "#04E7E0",
  colorBorderSubdued: "#E7E8EE",
  colorFocusDefault: "#04E7E0",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#E7E8EE",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#30536e",
  colorBrandLight: "#E1EFFA",
  colorBrandHover: "#304861",
  colorBrandActive: "#00263D",
  colorPrimaryDefault: "#02837F",
  colorPrimaryLight: "#DCFFFD",
  colorPrimaryLightHover: "#9AFEFA",
  colorPrimaryLightActive: "#04E7E0",
  colorPrimaryHover: "#01504E",
  colorPrimaryActive: "#013C3B",
  colorStatusDefault: "#6E7B9B",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#383F5B",
  colorStatusDefaultLight: "#E7E8EE",
  colorStatusPositiveDefault: "#00B046",
  colorStatusPositiveLight: "#CCFFE0",
  colorStatusPositiveActive: "#007630",
  colorStatusPositiveHover: "#00923B",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#007630",
  colorStatusWarningDefault: "#FBD245",
  colorStatusWarningLight: "#FFFBF0",
  colorStatusWarningActive: "#D7A705",
  colorStatusWarningHover: "#FAC614",
  colorStatusWarningBg: "#FFFBF0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#30536e",
  colorStatusInfoLight: "#E1EFFA",
  colorStatusInfoActive: "#00263D",
  colorStatusInfoHover: "#304861",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#00263D",
  colorTextSecondaryDefault: "#4D5770",
  colorTextTertiaryDefault: "#6E7B9B",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#959EB6",
  componentAccordionPrimaryBgColor: "#F6F6F9",
  componentAlertDefaultBorderColor: "#D2D5E0",
  componentAlertPositiveBorderColor: "#D2D5E0",
  componentAlertWarningBorderColor: "#D2D5E0",
  componentAlertNegativeBorderColor: "#D2D5E0",
  componentAlertInfoBorderColor: "#D2D5E0",
  componentAutocompleteInputContainerBorderColor: "#D2D5E0",
  componentButtonSecondaryBgColorDefault: "#DCFFFD",
  componentButtonSecondaryBgColorHover: "#9AFEFA",
  componentButtonSecondaryBgColorActive: "#04E7E0",
  componentButtonSecondaryBorderColorDefault: "#DCFFFD",
  componentButtonSecondaryBorderColorHover: "#9AFEFA",
  componentButtonSecondaryBorderColorActive: "#04E7E0",
  componentButtonSecondaryTextColorDefault: "#00263D",
  componentButtonSecondaryTextColorHover: "#00263D",
  componentButtonSecondaryTextColorActive: "#00263D",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#DCFFFD",
  componentButtonTertiaryBgColorActive: "#9AFEFA",
  componentButtonTertiaryBorderColorDefault: "#959EB6",
  componentButtonTertiaryBorderColorHover: "#01504E",
  componentButtonTertiaryBorderColorActive: "#01504E",
  componentButtonTertiaryTextColorDefault: "#01504E",
  componentButtonTertiaryTextColorHover: "#01504E",
  componentButtonTertiaryTextColorActive: "#013C3B",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#02837F",
  componentButtonLinkTextColorHover: "#01504E",
  componentButtonLinkTextColorActive: "#013C3B",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#02837F",
  componentButtonInvertedTextColorHover: "#01504E",
  componentButtonInvertedTextColorActive: "#013C3B",
  componentButtonInvertedDisabledBgColor: "#D2D5E0",
  componentButtonInvertedDisabledTextColor: "#959EB6",
  componentInputActiveBorderColor: "#959EB6",
  componentInputFocusBorderColor: "#959EB6"
};
var outline11 = {
  outlineDefault: "2px solid #04E7E0",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #04E7E0",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes11 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings11 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily11 = {
  fontFamilyPrimary: "'Open Sans', Arial, sans-serif",
  fontFamilySecondary: "Montserrat, 'Open Sans', Arial, sans-serif",
  fontFamilyBody: "'Open Sans', Arial, sans-serif",
  fontFamilyHeading: "Montserrat, 'Open Sans', Arial, sans-serif"
};
var fontSizes11 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights11 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights11 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices11 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight11 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers11 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes11 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/jobsite/index.ts
var jobsite_exports = {};
__export(jobsite_exports, {
  breakpoints: () => breakpoints12,
  colors: () => colors12,
  containers: () => containers12,
  fontFamily: () => fontFamily12,
  fontSizes: () => fontSizes12,
  fontWeights: () => fontWeights12,
  iconSizes: () => iconSizes12,
  lineHeights: () => lineHeights12,
  minHeight: () => minHeight12,
  outline: () => outline12,
  radii: () => radii12,
  shadows: () => shadows12,
  sizes: () => sizes12,
  spacings: () => spacings12,
  zIndices: () => zIndices12
});
var radii12 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows12 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #30536e",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints12 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors12 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#30536e",
  colorHighlightLight: "#F2F9F9",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#018380",
  colorAccentB2BLight: "#C8FAF9",
  colorAccentB2BHover: "#017370",
  colorAccentB2BActive: "#00615E",
  colorAccentB2CDefault: "#018380",
  colorAccentB2CLight: "#C8FAF9",
  colorAccentB2CHover: "#017370",
  colorAccentB2CActive: "#00615E",
  colorActionableDefault: "#00529B",
  colorActionableLightDefault: "#B2DBFF",
  colorActionableLightHover: "#75B3EB",
  colorActionableLightActive: "#4191D9",
  colorActionableHover: "#004280",
  colorActionableActive: "#003366",
  colorActionableB2CDefault: "#00529B",
  colorActionableB2CHover: "#004280",
  colorActionableB2CActive: "#003366",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#30536e",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#2c3e50",
  colorBrandLight: "#B2DBFF",
  colorBrandHover: "#304861",
  colorBrandActive: "#30536e",
  colorPrimaryDefault: "#018380",
  colorPrimaryLight: "#C8FAF9",
  colorPrimaryLightHover: "#ABEDEC",
  colorPrimaryLightActive: "#82D9D7",
  colorPrimaryHover: "#017370",
  colorPrimaryActive: "#00615E",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#00529B",
  colorStatusInfoLight: "#B2DBFF",
  colorStatusInfoActive: "#003366",
  colorStatusInfoHover: "#004280",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#C8FAF9",
  componentButtonSecondaryBgColorHover: "#ABEDEC",
  componentButtonSecondaryBgColorActive: "#82D9D7",
  componentButtonSecondaryBorderColorDefault: "#C8FAF9",
  componentButtonSecondaryBorderColorHover: "#ABEDEC",
  componentButtonSecondaryBorderColorActive: "#82D9D7",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#B2DBFF",
  componentButtonTertiaryBgColorActive: "#75B3EB",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#017370",
  componentButtonTertiaryBorderColorActive: "#017370",
  componentButtonTertiaryTextColorDefault: "#017370",
  componentButtonTertiaryTextColorHover: "#017370",
  componentButtonTertiaryTextColorActive: "#00615E",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#00529B",
  componentButtonLinkTextColorHover: "#004280",
  componentButtonLinkTextColorActive: "#003366",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#018380",
  componentButtonInvertedTextColorHover: "#017370",
  componentButtonInvertedTextColorActive: "#00615E",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline12 = {
  outlineDefault: "2px solid #30536e",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #30536e",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes12 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings12 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily12 = {
  fontFamilyPrimary: "'Open Sans', Arial, sans-serif",
  fontFamilySecondary: "Montserrat, 'Open Sans', Arial, sans-serif",
  fontFamilyBody: "'Open Sans', Arial, sans-serif",
  fontFamilyHeading: "Montserrat, 'Open Sans', Arial, sans-serif"
};
var fontSizes12 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights12 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights12 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices12 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight12 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers12 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes12 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/justengineers/index.ts
var justengineers_exports = {};
__export(justengineers_exports, {
  breakpoints: () => breakpoints13,
  colors: () => colors13,
  containers: () => containers13,
  fontFamily: () => fontFamily13,
  fontSizes: () => fontSizes13,
  fontWeights: () => fontWeights13,
  iconSizes: () => iconSizes13,
  lineHeights: () => lineHeights13,
  minHeight: () => minHeight13,
  outline: () => outline13,
  radii: () => radii13,
  shadows: () => shadows13,
  sizes: () => sizes13,
  spacings: () => spacings13,
  zIndices: () => zIndices13
});
var radii13 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows13 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints13 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors13 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#0056A4",
  colorHighlightLight: "#F3F7FB",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#0056A4",
  colorAccentB2BLight: "#CDE4F9",
  colorAccentB2BHover: "#03437D",
  colorAccentB2BActive: "#032E53",
  colorAccentB2CDefault: "#0056A4",
  colorAccentB2CLight: "#CDE4F9",
  colorAccentB2CHover: "#03437D",
  colorAccentB2CActive: "#032E53",
  colorActionableDefault: "#0056A4",
  colorActionableLightDefault: "#CDE4F9",
  colorActionableLightHover: "#96C8F5",
  colorActionableLightActive: "#539BDD",
  colorActionableHover: "#03437D",
  colorActionableActive: "#032E53",
  colorActionableB2CDefault: "#0056A4",
  colorActionableB2CHover: "#03437D",
  colorActionableB2CActive: "#032E53",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#0056A4",
  colorBrandLight: "#CDE4F9",
  colorBrandHover: "#03437D",
  colorBrandActive: "#032E53",
  colorPrimaryDefault: "#062540",
  colorPrimaryLight: "#CDE4F9",
  colorPrimaryLightHover: "#96C8F5",
  colorPrimaryLightActive: "#539BDD",
  colorPrimaryHover: "#032E53",
  colorPrimaryActive: "#03437D",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#0056A4",
  colorStatusInfoLight: "#CDE4F9",
  colorStatusInfoActive: "#032E53",
  colorStatusInfoHover: "#03437D",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#CDE4F9",
  componentButtonSecondaryBgColorHover: "#96C8F5",
  componentButtonSecondaryBgColorActive: "#539BDD",
  componentButtonSecondaryBorderColorDefault: "#CDE4F9",
  componentButtonSecondaryBorderColorHover: "#96C8F5",
  componentButtonSecondaryBorderColorActive: "#539BDD",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#CDE4F9",
  componentButtonTertiaryBgColorActive: "#96C8F5",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#032E53",
  componentButtonTertiaryBorderColorActive: "#032E53",
  componentButtonTertiaryTextColorDefault: "#032E53",
  componentButtonTertiaryTextColorHover: "#032E53",
  componentButtonTertiaryTextColorActive: "#03437D",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#0056A4",
  componentButtonLinkTextColorHover: "#03437D",
  componentButtonLinkTextColorActive: "#032E53",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#062540",
  componentButtonInvertedTextColorHover: "#032E53",
  componentButtonInvertedTextColorActive: "#03437D",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline13 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes13 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings13 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily13 = {
  fontFamilyPrimary: "'Open Sans', Arial, sans-serif",
  fontFamilySecondary: "'Roboto Slab', 'Open Sans', Arial, sans-serif",
  fontFamilyBody: "'Open Sans', Arial, sans-serif",
  fontFamilyHeading: "'Roboto Slab', 'Open Sans', Arial, sans-serif"
};
var fontSizes13 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights13 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights13 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices13 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight13 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers13 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes13 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/milkround/index.ts
var milkround_exports = {};
__export(milkround_exports, {
  breakpoints: () => breakpoints14,
  colors: () => colors14,
  containers: () => containers14,
  fontFamily: () => fontFamily14,
  fontSizes: () => fontSizes14,
  fontWeights: () => fontWeights14,
  iconSizes: () => iconSizes14,
  lineHeights: () => lineHeights14,
  minHeight: () => minHeight14,
  outline: () => outline14,
  radii: () => radii14,
  shadows: () => shadows14,
  sizes: () => sizes14,
  spacings: () => spacings14,
  zIndices: () => zIndices14
});
var radii14 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows14 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints14 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors14 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#34A4D6",
  colorHighlightLight: "#F2F7FA",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#E42A84",
  colorAccentB2BLight: "#FFD9EB",
  colorAccentB2BHover: "#C2196B",
  colorAccentB2BActive: "#B20C5D",
  colorAccentB2CDefault: "#E42A84",
  colorAccentB2CLight: "#FFD9EB",
  colorAccentB2CHover: "#C2196B",
  colorAccentB2CActive: "#B20C5D",
  colorActionableDefault: "#026B99",
  colorActionableLightDefault: "#D4EEFA",
  colorActionableLightHover: "#A2DFFB",
  colorActionableLightActive: "#74CEF5",
  colorActionableHover: "#00577C",
  colorActionableActive: "#004360",
  colorActionableB2CDefault: "#026B99",
  colorActionableB2CHover: "#00577C",
  colorActionableB2CActive: "#004360",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#00577C",
  colorBrandLight: "#D4EEFA",
  colorBrandHover: "#004360",
  colorBrandActive: "#00364D",
  colorPrimaryDefault: "#E42A84",
  colorPrimaryLight: "#FFD9EB",
  colorPrimaryLightHover: "#F2AACD",
  colorPrimaryLightActive: "#ED82B6",
  colorPrimaryHover: "#C2196B",
  colorPrimaryActive: "#B20C5D",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#026B99",
  colorStatusInfoLight: "#D4EEFA",
  colorStatusInfoActive: "#026B99",
  colorStatusInfoHover: "#168DC1",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#FFD9EB",
  componentButtonSecondaryBgColorHover: "#F2AACD",
  componentButtonSecondaryBgColorActive: "#ED82B6",
  componentButtonSecondaryBorderColorDefault: "#FFD9EB",
  componentButtonSecondaryBorderColorHover: "#F2AACD",
  componentButtonSecondaryBorderColorActive: "#ED82B6",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#D4EEFA",
  componentButtonTertiaryBgColorActive: "#A2DFFB",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#C2196B",
  componentButtonTertiaryBorderColorActive: "#C2196B",
  componentButtonTertiaryTextColorDefault: "#C2196B",
  componentButtonTertiaryTextColorHover: "#C2196B",
  componentButtonTertiaryTextColorActive: "#B20C5D",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#026B99",
  componentButtonLinkTextColorHover: "#00577C",
  componentButtonLinkTextColorActive: "#004360",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#E42A84",
  componentButtonInvertedTextColorHover: "#C2196B",
  componentButtonInvertedTextColorActive: "#B20C5D",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline14 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes14 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings14 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily14 = {
  fontFamilyPrimary: "Arial, sans-serif",
  fontFamilySecondary: "Lato, Arial, sans-serif",
  fontFamilyBody: "Arial, sans-serif",
  fontFamilyHeading: "Lato, Arial, sans-serif"
};
var fontSizes14 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights14 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights14 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices14 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight14 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers14 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes14 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/nijobs/index.ts
var nijobs_exports = {};
__export(nijobs_exports, {
  breakpoints: () => breakpoints15,
  colors: () => colors15,
  containers: () => containers15,
  fontFamily: () => fontFamily15,
  fontSizes: () => fontSizes15,
  fontWeights: () => fontWeights15,
  iconSizes: () => iconSizes15,
  lineHeights: () => lineHeights15,
  minHeight: () => minHeight15,
  outline: () => outline15,
  radii: () => radii15,
  shadows: () => shadows15,
  sizes: () => sizes15,
  spacings: () => spacings15,
  zIndices: () => zIndices15
});
var radii15 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows15 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #73D9F7",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints15 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors15 = {
  colorPureBlack: "#000000",
  colorBlack: "#323232",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#11BFF3",
  colorHighlightLight: "#F3FAFC",
  colorRating: "#F7E388",
  colorAccentB2BDefault: "#0A9BC7",
  colorAccentB2BLight: "#DDF6FD",
  colorAccentB2BHover: "#087597",
  colorAccentB2BActive: "#054F66",
  colorAccentB2CDefault: "#0A9BC7 ",
  colorAccentB2CLight: "#DDF6FD",
  colorAccentB2CHover: "#087597",
  colorAccentB2CActive: "#054F66",
  colorActionableDefault: "#0A9BC7",
  colorActionableLightDefault: "#DDF6FD",
  colorActionableLightHover: "#C5EFFB",
  colorActionableLightActive: "#A3E6FA",
  colorActionableHover: "#087597",
  colorActionableActive: "#054F66",
  colorActionableB2CDefault: "#0A9BC7",
  colorActionableB2CHover: "#087597",
  colorActionableB2CActive: "#054F66",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#73D9F7",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#73D9F7",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#4A4A4A",
  colorBrandLight: "#EBEBEB",
  colorBrandHover: "#323232",
  colorBrandActive: "#000000",
  colorPrimaryDefault: "#0A9BC7",
  colorPrimaryLight: "#DDF6FD",
  colorPrimaryLightHover: "#C5EFFB",
  colorPrimaryLightActive: "#A3E6FA",
  colorPrimaryHover: "#087597",
  colorPrimaryActive: "#054F66",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#F3D756",
  colorStatusWarningLight: "#FDF9E7",
  colorStatusWarningActive: "#D6B30F",
  colorStatusWarningHover: "#F0CC29",
  colorStatusWarningBg: "#FDF9E7",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#0A9BC7",
  colorStatusInfoLight: "#DDF6FD",
  colorStatusInfoActive: "#087597",
  colorStatusInfoHover: "#0A9BC7",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#E83232",
  colorStatusNegativeLightHover: "#F7BABA",
  colorStatusNegativeLightActive: "#F28C8C",
  colorStatusNegativeLight: "#FCE8E8",
  colorStatusNegativeActive: "#A11212",
  colorStatusNegativeHover: "#CE1717",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#A11212",
  colorTextPrimaryDefault: "#323232",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#DDF6FD",
  componentButtonSecondaryBgColorHover: "#C5EFFB",
  componentButtonSecondaryBgColorActive: "#A3E6FA",
  componentButtonSecondaryBorderColorDefault: "#DDF6FD",
  componentButtonSecondaryBorderColorHover: "#C5EFFB",
  componentButtonSecondaryBorderColorActive: "#A3E6FA",
  componentButtonSecondaryTextColorDefault: "#323232",
  componentButtonSecondaryTextColorHover: "#323232",
  componentButtonSecondaryTextColorActive: "#323232",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#DDF6FD",
  componentButtonTertiaryBgColorActive: "#C5EFFB",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#087597",
  componentButtonTertiaryBorderColorActive: "#087597",
  componentButtonTertiaryTextColorDefault: "#087597",
  componentButtonTertiaryTextColorHover: "#087597",
  componentButtonTertiaryTextColorActive: "#054F66",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#0A9BC7",
  componentButtonLinkTextColorHover: "#087597",
  componentButtonLinkTextColorActive: "#054F66",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#0A9BC7",
  componentButtonInvertedTextColorHover: "#087597",
  componentButtonInvertedTextColorActive: "#054F66",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline15 = {
  outlineDefault: "2px solid #73D9F7",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #73D9F7",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes15 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings15 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily15 = {
  fontFamilyPrimary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilySecondary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyBody: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyHeading: "'Helvetica Neue', Arial, sans-serif"
};
var fontSizes15 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights15 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights15 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices15 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight15 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers15 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes15 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/pnet/index.ts
var pnet_exports = {};
__export(pnet_exports, {
  breakpoints: () => breakpoints16,
  colors: () => colors16,
  containers: () => containers16,
  fontFamily: () => fontFamily16,
  fontSizes: () => fontSizes16,
  fontWeights: () => fontWeights16,
  iconSizes: () => iconSizes16,
  lineHeights: () => lineHeights16,
  minHeight: () => minHeight16,
  outline: () => outline16,
  radii: () => radii16,
  shadows: () => shadows16,
  sizes: () => sizes16,
  spacings: () => spacings16,
  zIndices: () => zIndices16
});
var radii16 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows16 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints16 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors16 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#BA1525",
  colorHighlightLight: "#FEF3F4",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#CCCCCC",
  colorAccentB2BLight: "#ffffff",
  colorAccentB2BHover: "#A6A6A6",
  colorAccentB2BActive: "#616161",
  colorAccentB2CDefault: "#7AAE1A",
  colorAccentB2CLight: "#E4EFD1",
  colorAccentB2CHover: "#6A9817",
  colorAccentB2CActive: "#618B14",
  colorActionableDefault: "#ED1B2E",
  colorActionableLightDefault: "#FFEAEC",
  colorActionableLightHover: "#FCBCC2",
  colorActionableLightActive: "#FA7D89",
  colorActionableHover: "#D90D1F",
  colorActionableActive: "#CD0315",
  colorActionableB2CDefault: "#ED1B2E",
  colorActionableB2CHover: "#D90D1F",
  colorActionableB2CActive: "#CD0315",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#BA1525",
  colorBrandLight: "#F1D0D3",
  colorBrandHover: "#AB0B1B",
  colorBrandActive: "#9B0514",
  colorPrimaryDefault: "#ED1B2E",
  colorPrimaryLight: "#FFEAEC",
  colorPrimaryLightHover: "#FCBCC2",
  colorPrimaryLightActive: "#FA7D89",
  colorPrimaryHover: "#D90D1F",
  colorPrimaryActive: "#CD0315",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#EBEBEB",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#F1FEEC",
  colorStatusPositiveFg: "#007630",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#A37B00",
  colorStatusInfoDefault: "#CCCCCC",
  colorStatusInfoLight: "#ffffff",
  colorStatusInfoActive: "#616161",
  colorStatusInfoHover: "#A6A6A6",
  colorStatusInfoBg: "#ffffff",
  colorStatusInfoFg: "#616161",
  colorStatusNegativeDefault: "#BA1525",
  colorStatusNegativeLightHover: "#EF939C",
  colorStatusNegativeLightActive: "#E2626E",
  colorStatusNegativeLight: "#F1D0D3",
  colorStatusNegativeActive: "#9B0514",
  colorStatusNegativeHover: "#AB0B1B",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9B0514",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#FFEAEC",
  componentButtonSecondaryBgColorHover: "#FCBCC2",
  componentButtonSecondaryBgColorActive: "#FA7D89",
  componentButtonSecondaryBorderColorDefault: "#FFEAEC",
  componentButtonSecondaryBorderColorHover: "#FCBCC2",
  componentButtonSecondaryBorderColorActive: "#FA7D89",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#FFEAEC",
  componentButtonTertiaryBgColorActive: "#FCBCC2",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#D90D1F",
  componentButtonTertiaryBorderColorActive: "#D90D1F",
  componentButtonTertiaryTextColorDefault: "#D90D1F",
  componentButtonTertiaryTextColorHover: "#D90D1F",
  componentButtonTertiaryTextColorActive: "#CD0315",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#ED1B2E",
  componentButtonLinkTextColorHover: "#D90D1F",
  componentButtonLinkTextColorActive: "#CD0315",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#ED1B2E",
  componentButtonInvertedTextColorHover: "#D90D1F",
  componentButtonInvertedTextColorActive: "#CD0315",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline16 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes16 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings16 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily16 = {
  fontFamilyPrimary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilySecondary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyBody: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyHeading: "'Helvetica Neue', Arial, sans-serif"
};
var fontSizes16 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights16 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights16 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices16 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight16 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers16 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes16 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/retailchoice/index.ts
var retailchoice_exports = {};
__export(retailchoice_exports, {
  breakpoints: () => breakpoints17,
  colors: () => colors17,
  containers: () => containers17,
  fontFamily: () => fontFamily17,
  fontSizes: () => fontSizes17,
  fontWeights: () => fontWeights17,
  iconSizes: () => iconSizes17,
  lineHeights: () => lineHeights17,
  minHeight: () => minHeight17,
  outline: () => outline17,
  radii: () => radii17,
  shadows: () => shadows17,
  sizes: () => sizes17,
  spacings: () => spacings17,
  zIndices: () => zIndices17
});
var radii17 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows17 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints17 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors17 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#00577C",
  colorHighlightLight: "#FBF2F8",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#B90078",
  colorAccentB2BLight: "#FFCCED",
  colorAccentB2BHover: "#9F0067",
  colorAccentB2BActive: "#860057",
  colorAccentB2CDefault: "#B90078",
  colorAccentB2CLight: "#FFCCED",
  colorAccentB2CHover: "#9F0067",
  colorAccentB2CActive: "#860057",
  colorActionableDefault: "#00577C",
  colorActionableLightDefault: "#D0ECF5",
  colorActionableLightHover: "#99DEF5",
  colorActionableLightActive: "#73BED9",
  colorActionableHover: "#004461",
  colorActionableActive: "#003951",
  colorActionableB2CDefault: "#00577C",
  colorActionableB2CHover: "#004461",
  colorActionableB2CActive: "#003951",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#00577C",
  colorBrandLight: "#D0ECF5",
  colorBrandHover: "#004461",
  colorBrandActive: "#003951",
  colorPrimaryDefault: "#B90078",
  colorPrimaryLight: "#FFCCED",
  colorPrimaryLightHover: "#F29DD4",
  colorPrimaryLightActive: "#E57EC1",
  colorPrimaryHover: "#9F0067",
  colorPrimaryActive: "#860057",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#00577C",
  colorStatusInfoLight: "#D0ECF5",
  colorStatusInfoActive: "#003951",
  colorStatusInfoHover: "#004461",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#FFCCED",
  componentButtonSecondaryBgColorHover: "#F29DD4",
  componentButtonSecondaryBgColorActive: "#E57EC1",
  componentButtonSecondaryBorderColorDefault: "#FFCCED",
  componentButtonSecondaryBorderColorHover: "#F29DD4",
  componentButtonSecondaryBorderColorActive: "#E57EC1",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#D0ECF5",
  componentButtonTertiaryBgColorActive: "#99DEF5",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#9F0067",
  componentButtonTertiaryBorderColorActive: "#9F0067",
  componentButtonTertiaryTextColorDefault: "#9F0067",
  componentButtonTertiaryTextColorHover: "#9F0067",
  componentButtonTertiaryTextColorActive: "#860057",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#00577C",
  componentButtonLinkTextColorHover: "#004461",
  componentButtonLinkTextColorActive: "#003951",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#B90078",
  componentButtonInvertedTextColorHover: "#9F0067",
  componentButtonInvertedTextColorActive: "#860057",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline17 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes17 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings17 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily17 = {
  fontFamilyPrimary: "Arial, sans-serif",
  fontFamilySecondary: "'Gothic A1', Arial, sans-serif",
  fontFamilyBody: "Arial, sans-serif",
  fontFamilyHeading: "'Gothic A1', Arial, sans-serif"
};
var fontSizes17 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights17 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights17 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices17 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight17 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers17 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes17 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/stepstone/index.ts
var stepstone_exports = {};
__export(stepstone_exports, {
  breakpoints: () => breakpoints18,
  colors: () => colors18,
  containers: () => containers18,
  fontFamily: () => fontFamily18,
  fontSizes: () => fontSizes18,
  fontWeights: () => fontWeights18,
  iconSizes: () => iconSizes18,
  lineHeights: () => lineHeights18,
  minHeight: () => minHeight18,
  outline: () => outline18,
  radii: () => radii18,
  shadows: () => shadows18,
  sizes: () => sizes18,
  spacings: () => spacings18,
  zIndices: () => zIndices18
});
var radii18 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows18 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #0C2577",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #DCDFE2, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #DCDFE2, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints18 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors18 = {
  colorPureBlack: "#000000",
  colorBlack: "#292A36",
  colorGreyDarker: "#3A434F",
  colorGreyDark: "#566578",
  colorGrey: "#8E97A4",
  colorGreyLight: "#B3B9C1",
  colorGreyLighter: "#DCDFE2",
  colorOffWhite: "#f5f5f5",
  colorWhite: "#ffffff",
  colorHighlight: "#0C2577",
  colorHighlightLight: "#F5F9FE",
  colorRating: "#F1B628",
  colorAccentB2BDefault: "#D54500",
  colorAccentB2BLight: "#F7DACC",
  colorAccentB2BHover: "#B93C00",
  colorAccentB2BActive: "#AA3700",
  colorAccentB2CDefault: "#7AAE1A",
  colorAccentB2CLight: "#E4EFD1",
  colorAccentB2CHover: "#6A9817",
  colorAccentB2CActive: "#618B14",
  colorActionableDefault: "#4088EE",
  colorActionableLightDefault: "#D8E7FB",
  colorActionableLightHover: "#B3D1FA",
  colorActionableLightActive: "#95C0F9",
  colorActionableHover: "#397AD5",
  colorActionableActive: "#336CBE",
  colorActionableB2CDefault: "#4088EE",
  colorActionableB2CHover: "#397AD5",
  colorActionableB2CActive: "#336CBE",
  colorBorderDefault: "#DCDFE2",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EEF0F1",
  colorFocusDefault: "#0C2577",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EEF0F1",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#0C2577",
  colorBrandLight: "#CED3E3",
  colorBrandHover: "#0A216A",
  colorBrandActive: "#091D5F",
  colorPrimaryDefault: "#4088EE",
  colorPrimaryLight: "#D8E7FB",
  colorPrimaryLightHover: "#B3D1FA",
  colorPrimaryLightActive: "#95C0F9",
  colorPrimaryHover: "#397AD5",
  colorPrimaryActive: "#336CBE",
  colorStatusDefault: "#8E97A4",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#3A434F",
  colorStatusDefaultLight: "#EEF0F1",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#D2F3DD",
  colorStatusPositiveActive: "#02AE3C",
  colorStatusPositiveHover: "#0BB644",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#02AE3C",
  colorStatusWarningDefault: "#EBA600",
  colorStatusWarningLight: "#FBEDCC",
  colorStatusWarningActive: "#CD9100",
  colorStatusWarningHover: "#DC9B00",
  colorStatusWarningBg: "#FBEDCC",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#4088EE",
  colorStatusInfoLight: "#D8E7FB",
  colorStatusInfoActive: "#336CBE",
  colorStatusInfoHover: "#397AD5",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#E45E6A",
  colorStatusNegativeLightHover: "#FFC3C9",
  colorStatusNegativeLightActive: "#FCA4AC",
  colorStatusNegativeLight: "#FADFE1",
  colorStatusNegativeActive: "#C2303D",
  colorStatusNegativeHover: "#D74653",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#C2303D",
  colorTextPrimaryDefault: "#292A36",
  colorTextSecondaryDefault: "#566578",
  colorTextTertiaryDefault: "#8E97A4",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#B3B9C1",
  componentAccordionPrimaryBgColor: "#f5f5f5",
  componentAlertDefaultBorderColor: "#DCDFE2",
  componentAlertPositiveBorderColor: "#DCDFE2",
  componentAlertWarningBorderColor: "#DCDFE2",
  componentAlertNegativeBorderColor: "#DCDFE2",
  componentAlertInfoBorderColor: "#DCDFE2",
  componentAutocompleteInputContainerBorderColor: "#DCDFE2",
  componentButtonSecondaryBgColorDefault: "#D8E7FB",
  componentButtonSecondaryBgColorHover: "#B3D1FA",
  componentButtonSecondaryBgColorActive: "#95C0F9",
  componentButtonSecondaryBorderColorDefault: "#D8E7FB",
  componentButtonSecondaryBorderColorHover: "#B3D1FA",
  componentButtonSecondaryBorderColorActive: "#95C0F9",
  componentButtonSecondaryTextColorDefault: "#292A36",
  componentButtonSecondaryTextColorHover: "#292A36",
  componentButtonSecondaryTextColorActive: "#292A36",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#D8E7FB",
  componentButtonTertiaryBgColorActive: "#B3D1FA",
  componentButtonTertiaryBorderColorDefault: "#B3B9C1",
  componentButtonTertiaryBorderColorHover: "#397AD5",
  componentButtonTertiaryBorderColorActive: "#397AD5",
  componentButtonTertiaryTextColorDefault: "#397AD5",
  componentButtonTertiaryTextColorHover: "#397AD5",
  componentButtonTertiaryTextColorActive: "#336CBE",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#4088EE",
  componentButtonLinkTextColorHover: "#397AD5",
  componentButtonLinkTextColorActive: "#336CBE",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#4088EE",
  componentButtonInvertedTextColorHover: "#397AD5",
  componentButtonInvertedTextColorActive: "#336CBE",
  componentButtonInvertedDisabledBgColor: "#DCDFE2",
  componentButtonInvertedDisabledTextColor: "#B3B9C1",
  componentInputActiveBorderColor: "#B3B9C1",
  componentInputFocusBorderColor: "#B3B9C1"
};
var outline18 = {
  outlineDefault: "2px solid #0C2577",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #0C2577",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes18 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings18 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily18 = {
  fontFamilyPrimary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilySecondary: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyBody: "'Helvetica Neue', Arial, sans-serif",
  fontFamilyHeading: "'Helvetica Neue', Arial, sans-serif"
};
var fontSizes18 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights18 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights18 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices18 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight18 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers18 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes18 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};

// src/themes/totaljobs/index.ts
var totaljobs_exports = {};
__export(totaljobs_exports, {
  breakpoints: () => breakpoints19,
  colors: () => colors19,
  containers: () => containers19,
  fontFamily: () => fontFamily19,
  fontSizes: () => fontSizes19,
  fontWeights: () => fontWeights19,
  iconSizes: () => iconSizes19,
  lineHeights: () => lineHeights19,
  minHeight: () => minHeight19,
  outline: () => outline19,
  radii: () => radii19,
  shadows: () => shadows19,
  sizes: () => sizes19,
  spacings: () => spacings19,
  zIndices: () => zIndices19
});
var radii19 = {
  radiusNone: "0px",
  radiusM: "4px",
  radiusM2: "6px",
  radiusL: "8px",
  radiusL2: "10px",
  radiusL4: "12px",
  radiusXl: "16px",
  radiusRound: "999px",
  componentAlertRadius: "4px",
  componentAutocompleteInputBorderRadius: "4px",
  componentAutocompleteInputBorderBottomRadius: "4px",
  componentAutocompleteInputBorderTopRadius: "4px",
  componentAutocompleteInputGroupLastChildRaidus: "invalid",
  componentAutocompletePopoverBorderRadius: "4px",
  componentAutocompletePopoverBorderBottomRadius: "4px",
  componentAutocompletePopoverBorderTopRadius: "4px",
  componentAvatarXxsRadius: "999px",
  componentAvatarXsRadius: "999px",
  componentAvatarSmallRadius: "999px",
  componentAvatarMediumRadius: "999px",
  componentAvatarLargeRadius: "999px",
  componentAvatarXlRadius: "999px",
  componentButtonSmallRadius: "4px",
  componentButtonMediumRadius: "4px",
  componentButtonLargeRadius: "4px",
  componentCompanyLogoInnerRadius: "4px",
  componentCompanyLogoXsRadius: "4px",
  componentCompanyLogoXsInnerRadius: "2px",
  componentCompanyLogoSmallRadius: "4px",
  componentCompanyLogoSmallInnerRadius: "2px",
  componentCompanyLogoMediumRadius: "4px",
  componentCompanyLogoMediumInnerRadius: "2px",
  componentCompanyLogoLargeRadius: "4px",
  componentCompanyLogoLargeInnerRadius: "2px",
  componentCompanyLogoXlRadius: "4px",
  componentCompanyLogoXlInnerRadius: "2px",
  componentDrawerRadius: "0px",
  componentMenuRadius: "4px",
  componentTokenRadius: "999px"
};
var shadows19 = {
  boxShadowNone: "none",
  boxShadowBorderDefault: "inset 0 0 0 1px",
  boxShadowBorderLine: "inset 0 2px 1px -1px",
  boxShadowBorderActionable: "0 0 0 3px",
  boxShadowBorderHorizontal: "inset 0 1px,inset 0 -1px",
  boxShadowBorderVertical: "inset 1px 0,inset -1px 0",
  boxShadowFocusDefault: "0 0 0 2px #CCCCCC",
  boxShadowFocusWhite: "0 0 0 2px #ffffff",
  boxShadowElevationS: "0 2px 16px rgba(0, 0, 0, 0.08)",
  boxShadowElevationM: "0 4px 16px rgba(0, 0, 0, 0.12)",
  boxShadowElevationL: "0 24px 32px rgba(0, 0, 0, 0.15)",
  boxShadowElevationXl: "0 24px 56px rgba(0, 0, 0, 0.08)",
  componentAlertBoxShadow: "none",
  componentAlertDisplayBefore: "block",
  componentAutocompleteInputGroupLastChildBoxShadow: "invalid",
  componentAutocompletePopoverBoxShadowBottom: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentAutocompletePopoverBoxShadowTop: "0 0 0 1px #E0E0E0, 0 4px 16px rgba(0, 0, 0, 0.12)",
  componentButtonPrimaryBoxShadow: "none",
  componentButtonSecondaryBoxShadow: "none",
  componentButtonTertiaryBoxShadow: "none",
  componentButtonInvertedBoxShadow: "none"
};
var breakpoints19 = {
  breakpointS: "600px",
  breakpointM: "900px",
  breakpointL: "1200px",
  breakpointXl: "1800px"
};
var colors19 = {
  colorPureBlack: "#000000",
  colorBlack: "#333333",
  colorGreyDarker: "#4A4A4A",
  colorGreyDark: "#616161",
  colorGrey: "#A6A6A6",
  colorGreyLight: "#CCCCCC",
  colorGreyLighter: "#E0E0E0",
  colorOffWhite: "#F7F7F7",
  colorWhite: "#ffffff",
  colorHighlight: "#3CBF0A",
  colorHighlightLight: "#FDF6F2",
  colorRating: "#FCC738",
  colorAccentB2BDefault: "#DD5800",
  colorAccentB2BLight: "#F8DDCC",
  colorAccentB2BHover: "#C64F00",
  colorAccentB2BActive: "#B04600",
  colorAccentB2CDefault: "#DD5800",
  colorAccentB2CLight: "#F8DDCC",
  colorAccentB2CHover: "#C64F00",
  colorAccentB2CActive: "#B04600",
  colorActionableDefault: "#007BFF",
  colorActionableLightDefault: "#CCE5FF",
  colorActionableLightHover: "#99CAFF",
  colorActionableLightActive: "#66B0FF",
  colorActionableHover: "#0062CD",
  colorActionableActive: "#004A99",
  colorActionableB2CDefault: "#169000",
  colorActionableB2CHover: "#138100",
  colorActionableB2CActive: "#117000",
  colorBorderDefault: "#E0E0E0",
  colorBorderFocus: "#000000",
  colorBorderSubdued: "#EBEBEB",
  colorFocusDefault: "#CCCCCC",
  colorFocusWhite: "#ffffff",
  colorBackgroundPrimaryDefault: "#F2F3F6",
  colorBackgroundPrimaryLight: "#F2F3F6",
  colorBackgroundPrimaryLighter: "#F2F3F6",
  colorBackgroundPrimaryDark: "#F2F3F6",
  colorBackgroundSecondaryDefault: "#F2F3F6",
  colorBackgroundSecondaryLight: "#F2F3F6",
  colorBackgroundSecondaryDark: "#EBEBEB",
  colorBackgroundLight: "#F2F3F6",
  colorBackgroundDisabledDefault: "#F2F3F6",
  colorBrandDefault: "#3CBF0A",
  colorBrandLight: "#D8F2CE",
  colorBrandHover: "#35AB08",
  colorBrandActive: "#169000",
  colorPrimaryDefault: "#DD5800",
  colorPrimaryLight: "#F8DDCC",
  colorPrimaryLightHover: "#F8BB95",
  colorPrimaryLightActive: "#F39D63",
  colorPrimaryHover: "#C64F00",
  colorPrimaryActive: "#B04600",
  colorStatusDefault: "#A6A6A6",
  colorStatusDefaultBg: "#F2F3F6",
  colorStatusDefaultFg: "#4A4A4A",
  colorStatusDefaultLight: "#EBEBEB",
  colorStatusPositiveDefault: "#1CC454",
  colorStatusPositiveLight: "#F1FEEC",
  colorStatusPositiveActive: "#03A83A",
  colorStatusPositiveHover: "#10BB49",
  colorStatusPositiveBg: "#E5FFF0",
  colorStatusPositiveFg: "#03A83A",
  colorStatusWarningDefault: "#f9bc15",
  colorStatusWarningLight: "#FDF1D0",
  colorStatusWarningActive: "#D19900",
  colorStatusWarningHover: "#EAAC04",
  colorStatusWarningBg: "#FDF1D0",
  colorStatusWarningFg: "#7A5C00",
  colorStatusInfoDefault: "#007BFF",
  colorStatusInfoLight: "#CCE5FF",
  colorStatusInfoActive: "#004A99",
  colorStatusInfoHover: "#0062CD",
  colorStatusInfoBg: "#E1F6F7",
  colorStatusInfoFg: "#003954",
  colorStatusNegativeDefault: "#d10000",
  colorStatusNegativeLightHover: "#F49494",
  colorStatusNegativeLightActive: "#EA5454",
  colorStatusNegativeLight: "#F5CCCC",
  colorStatusNegativeActive: "#9C0000",
  colorStatusNegativeHover: "#B90202",
  colorStatusNegativeBg: "#FFEBED",
  colorStatusNegativeFg: "#9C0000",
  colorTextPrimaryDefault: "#333333",
  colorTextSecondaryDefault: "#616161",
  colorTextTertiaryDefault: "#A6A6A6",
  colorTextInvertedDefault: "#ffffff",
  colorTextInvertedHover: "#F2F3F6",
  colorTextDisabledDefault: "#CCCCCC",
  componentAccordionPrimaryBgColor: "#F7F7F7",
  componentAlertDefaultBorderColor: "#E0E0E0",
  componentAlertPositiveBorderColor: "#E0E0E0",
  componentAlertWarningBorderColor: "#E0E0E0",
  componentAlertNegativeBorderColor: "#E0E0E0",
  componentAlertInfoBorderColor: "#E0E0E0",
  componentAutocompleteInputContainerBorderColor: "#E0E0E0",
  componentButtonSecondaryBgColorDefault: "#F8DDCC",
  componentButtonSecondaryBgColorHover: "#F8BB95",
  componentButtonSecondaryBgColorActive: "#F39D63",
  componentButtonSecondaryBorderColorDefault: "#F8DDCC",
  componentButtonSecondaryBorderColorHover: "#F8BB95",
  componentButtonSecondaryBorderColorActive: "#F39D63",
  componentButtonSecondaryTextColorDefault: "#333333",
  componentButtonSecondaryTextColorHover: "#333333",
  componentButtonSecondaryTextColorActive: "#333333",
  componentButtonTertiaryBgColorDefault: "#ffffff",
  componentButtonTertiaryBgColorHover: "#CCE5FF",
  componentButtonTertiaryBgColorActive: "#99CAFF",
  componentButtonTertiaryBorderColorDefault: "#CCCCCC",
  componentButtonTertiaryBorderColorHover: "#C64F00",
  componentButtonTertiaryBorderColorActive: "#C64F00",
  componentButtonTertiaryTextColorDefault: "#C64F00",
  componentButtonTertiaryTextColorHover: "#C64F00",
  componentButtonTertiaryTextColorActive: "#B04600",
  componentButtonLinkTextDecoration: "underline",
  componentButtonLinkTextColorDefault: "#007BFF",
  componentButtonLinkTextColorHover: "#0062CD",
  componentButtonLinkTextColorActive: "#004A99",
  componentButtonInvertedBgColorDefault: "#ffffff",
  componentButtonInvertedBgColorHover: "#ffffff",
  componentButtonInvertedBgColorActive: "#ffffff",
  componentButtonInvertedBorderColorDefault: "#ffffff",
  componentButtonInvertedBorderColorHover: "#ffffff",
  componentButtonInvertedBorderColorActive: "#ffffff",
  componentButtonInvertedTextColorDefault: "#DD5800",
  componentButtonInvertedTextColorHover: "#C64F00",
  componentButtonInvertedTextColorActive: "#B04600",
  componentButtonInvertedDisabledBgColor: "#E0E0E0",
  componentButtonInvertedDisabledTextColor: "#CCCCCC",
  componentInputActiveBorderColor: "#CCCCCC",
  componentInputFocusBorderColor: "#CCCCCC"
};
var outline19 = {
  outlineDefault: "2px solid #CCCCCC",
  outlineNone: "0px solid transparent",
  outlineOffset0: "0px",
  outlineOffset20: "2px",
  componentAutocompleteInputContainerOutline: "2px solid #CCCCCC",
  componentAutocompleteInputGroupOutline: "0px solid transparent"
};
var sizes19 = {
  size10: "8px",
  size12: "10px",
  size15: "12px",
  size20: "16px",
  size25: "20px",
  size30: "24px",
  size35: "28px",
  size40: "32px",
  size50: "40px",
  size60: "48px",
  size65: "52px",
  size70: "56px",
  size80: "64px",
  size90: "72px",
  size100: "80px",
  size110: "88px",
  size120: "96px",
  size130: "104px",
  size140: "112px",
  size150: "120px",
  size160: "128px",
  size170: "136px",
  size180: "144px",
  size190: "152px",
  size200: "160px",
  size300: "240px",
  size400: "320px",
  size500: "400px",
  size00: "0px",
  size01: "1px",
  size02: "2px",
  size05: "4px",
  size07: "6px",
  componentButtonMediumSize: "40px",
  componentDialogSize: "48px"
};
var spacings19 = {
  spaceAuto: "auto",
  spaceFull: "100%",
  spaceNone: 0,
  spaceXxs: "2px",
  spaceXs: "4px",
  spaceS: "8px",
  spaceS2: "12px",
  spaceM: "16px",
  spaceL: "24px",
  spaceXl: "32px",
  spaceXxl: "64px",
  spaceXxxl: "128px",
  componentAlertPadding: "16px",
  componentAutocompletePopoverPadding: "16px 0 16px 0",
  componentAutocompletePopoverOffset: "8px",
  componentButtonLargePaddingX: "20px",
  componentCompanyLogoXsPadding: "1px",
  componentCompanyLogoSmallPadding: "1px",
  componentCompanyLogoMediumPadding: "1px",
  componentCompanyLogoLargePadding: "1px",
  componentCompanyLogoXlPadding: "1px",
  componentInputFocusOutlineOffset: "2px",
  componentMenuPaddingY: "4px",
  componentTagSmallPaddingX: "4px",
  componentTagMediumPaddingX: "8px",
  componentTagLargePaddingX: "12px"
};
var fontFamily19 = {
  fontFamilyPrimary: "TotalSans, Arial, sans-serif",
  fontFamilySecondary: "TotalSans, Arial, sans-serif",
  fontFamilyBody: "TotalSans, Arial, sans-serif",
  fontFamilyHeading: "TotalSans, Arial, sans-serif"
};
var fontSizes19 = {
  fontSizeNone: "0px",
  fontSizeXxs: "10px",
  fontSizeXs: "12px",
  fontSizeS: "14px",
  fontSizeM: "16px",
  fontSizeL: "18px",
  fontSizeXl: "22px",
  fontSizeXxl: "30px",
  fontSizeXxxl: "42px",
  fontSize4Xl: "64px",
  componentHeadingTitleLargeFontSize: "48px",
  componentHeadingTitleLargeMobileFontSize: "32px",
  componentHeadingTitleFontSize: "32px",
  componentHeadingTitleMobileFontSize: "24px",
  componentHeadingHeadingMobileFontSize: "20px",
  componentHeadingSubHeadingFontSize: "20px",
  componentHeadingHeroFontSize: "56px",
  componentHeadingHeroMobileFontSize: "32px",
  componentHeadingSuperHeroFontSize: "74px",
  componentHeadingMegaHeroFontSize: "96px"
};
var fontWeights19 = {
  fontWeightHairline: 100,
  fontWeightThin: 200,
  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  fontWeightExtrabold: 800,
  fontWeightBlack: 900,
  componentButtonLargeFontWeight: 700
};
var lineHeights19 = {
  lineHeightNone: "0px",
  lineHeightXxs: "16px",
  lineHeightXs: "20px",
  lineHeightS: "24px",
  lineHeightM: "24px",
  lineHeightL: "28px",
  lineHeightXl: "32px",
  lineHeightXxl: "40px",
  lineHeightXxxl: "48px",
  lineHeight4Xl: "72px",
  componentHeadingTitleLargeLineHeight: "54px",
  componentHeadingTitleLargeMobileLineHeight: "36px",
  componentHeadingTitleLineHeight: "36px",
  componentHeadingTitleMobileLineHeight: "36px",
  componentHeadingHeadingLineHeight: "30px",
  componentHeadingHeadingMobileLineHeight: "30px",
  componentHeadingSubHeadingLineHeight: "36px",
  componentHeadingSubHeadingMobileLineHeight: "26px",
  componentHeadingHeroLineHeight: "64px",
  componentHeadingSuperHeroLineHeight: "84px",
  componentHeadingMegaHeroLineHeight: "100px",
  componentParagraphBodyLargeLineHeight: "26px",
  componentParagraphCaptionLineHeight: "18px",
  componentParagraphMiniLineHeight: "14px"
};
var zIndices19 = {
  zIndex0: 0,
  zIndex10: 10,
  zIndex20: 20,
  zIndex30: 30,
  zIndex40: 40,
  zIndex50: 50,
  zIndex60: 60,
  zIndex70: 70,
  zIndex80: 80,
  zIndex90: 90,
  zIndex100: 100
};
var minHeight19 = {
  componentTagSmallMinHeight: "20px",
  componentTagMediumMinHeight: "24px",
  componentTagLargeMinHeight: "32px"
};
var containers19 = {
  containerS: "100%",
  containerM: "100%",
  containerL: "1200px",
  containerXl: "1800px"
};
var iconSizes19 = {
  iconSizeXs: "12px",
  iconSizeS: "16px",
  iconSizeM: "20px",
  iconSizeL: "24px",
  iconSizeXl: "28px",
  iconSizeXxl: "32px",
  iconSizeXxxl: "48px"
};
export {
  base_exports as base,
  careerstructure_exports as careerstructure,
  caterer_exports as caterer,
  catererglobal_exports as catererglobal,
  cityjobs_exports as cityjobs,
  core_exports as core,
  coretwentyfive_exports as coretwentyfive,
  cwjobs_exports as cwjobs,
  emedcareers_exports as emedcareers,
  irishjobs_exports as irishjobs,
  jobsie_exports as jobsie,
  jobsite_exports as jobsite,
  justengineers_exports as justengineers,
  milkround_exports as milkround,
  nijobs_exports as nijobs,
  pnet_exports as pnet,
  retailchoice_exports as retailchoice,
  stepstone_exports as stepstone,
  totaljobs_exports as totaljobs
};
